var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174 30",
    style: {
      enableBackground: "new 0 0 174 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;}\n\t.st1{fill:#081F2A;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#081F2A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.9,25.9c0-2.5,1.9-4.1,4.3-4.1c1.1,0,2.3,0.4,2.9,1.1l-1.3,1.3c-0.4-0.5-1-0.7-1.6-0.7 c-1.3,0-2.3,1-2.3,2.4c0,1.4,0.9,2.4,2.2,2.4c0.7,0,1.3-0.3,1.7-0.8l1.3,1.2c-0.7,0.8-1.7,1.3-3,1.3C45.8,30,43.9,28.3,43.9,25.9 L43.9,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,25.9c0-2.5,1.8-4.1,4.3-4.1c2.4,0,4.3,1.6,4.3,4.1S60.4,30,58,30C55.5,30,53.7,28.3,53.7,25.9z  M60.2,25.9c0-1.4-0.9-2.4-2.2-2.4c-1.3,0-2.2,1-2.2,2.4c0,1.4,0.9,2.4,2.2,2.4S60.2,27.3,60.2,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,22h1.9v6.2h3v1.6h-4.9V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.7,22h1.9v6.2h3v1.6h-4.9V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.7,22H87v1.6h-3.4v1.5h3.3v1.5h-3.3v1.6h3.6v1.6h-5.5V22L81.7,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.3,25.9c0-2.5,1.9-4.1,4.3-4.1c1.1,0,2.3,0.4,2.9,1.1l-1.3,1.3c-0.4-0.5-1-0.7-1.6-0.7 c-1.3,0-2.3,1-2.3,2.4c0,1.4,0.9,2.4,2.2,2.4c0.7,0,1.3-0.3,1.7-0.8l1.3,1.2c-0.7,0.8-1.7,1.3-3,1.3C92.1,30,90.3,28.3,90.3,25.9 L90.3,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102,23.6h-2.2V22h6.3v1.6h-2.2v6.2H102V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.1,22h1.9v7.8h-1.9V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,22h2.1l1.8,5.5h0l1.8-5.5h2.1l-3,7.8h-1.9L113.9,22L113.9,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,22h5.3v1.6h-3.4v1.5h3.3v1.5h-3.3v1.6h3.6v1.6h-5.5V22L124.6,22z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59,4.4v2h5.7v0.5c0,0.5-0.4,0.9-0.9,0.9h-7.3c-0.5,0-0.9-0.4-0.9-0.9V3.2c0-0.5,0.4-0.9,0.9-0.9h7.3 c0.5,0,0.9,0.4,0.9,0.9v0.1h2.7l0-0.7C67.3,1.2,66.2,0,64.7,0l-4.5,0l-4.5,0c-1.5,0-2.6,1.2-2.7,2.7c-0.1,1.6-0.1,3.1,0,4.7 c0.1,1.5,1.2,2.7,2.7,2.7l4.5,0l4.5,0c1.5,0,2.6-1.2,2.8-2.7c0.1-1,0.1-2,0.1-3.1H59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M145.8,7.7V6.1h8.8V4h-8.8V2.5H156l0-2.3h-13v9.7h13l0-2.2H145.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133,7.6l-5.2-7.4l-3.4,0l7,9.7h1.7h1.7l7-9.7l-3.4,0L133,7.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.5,6.7l-8.1-6.5l-4.4,0v9.7h2.9V2.7l9,7.2h3.5V0.2h-2.8V6.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.2,2.5l0-2.3h-13v9.7h13l0-2.2H73V6.1h8.8V4H73V2.5H83.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.3,0.2l-7,9.7h3.4l1.4-1.9h7.7l1.4,1.9h3.4l-7-9.7C25.5,0.2,24.4,0.2,23.3,0.2z M25,5.9h-2.4L25,2.5l2.4,3.4 H25z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.5,3.4c0-1.7-1.4-3.2-3.2-3.2H0v9.7h2.8V6.5h5.9l2.9,3.4h3.7l-3-3.5C13.6,6,14.5,4.8,14.5,3.4L14.5,3.4z  M10.7,4.2L10.7,4.2H2.8V2.5h7.9c0.5,0,0.9,0.4,0.9,0.9S11.2,4.2,10.7,4.2L10.7,4.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.5,3.4c0-1.7-1.4-3.2-3.2-3.2H91.9v9.7h2.8V6.5h5.9l2.9,3.4h3.7l-3-3.5C105.5,6,106.5,4.8,106.5,3.4 L106.5,3.4z M102.6,4.2L102.6,4.2h-7.9V2.5h7.9c0.5,0,0.9,0.4,0.9,0.9S103.1,4.2,102.6,4.2L102.6,4.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171,6.4c1.3-0.4,2.3-1.6,2.3-3c0-1.7-1.4-3.2-3.2-3.2h-11.4v9.7h2.8V6.5h5.9l2.9,3.4h3.7L171,6.4L171,6.4z  M169.5,4.2L169.5,4.2h-7.9V2.5h7.9c0.5,0,0.9,0.4,0.9,0.9S169.9,4.2,169.5,4.2L169.5,4.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.5,2.7c-0.1-1.5-1.2-2.7-2.7-2.7l-4.5,0l-4.5,0c-1.5,0-2.6,1.2-2.7,2.7l-0.1,1l0,1.3l0,1l0.1,1.3 c0.1,1.5,1.2,2.7,2.7,2.7l4.4,0l4.5,0c1.5,0,2.6-1.2,2.7-2.7l0.1-1l0-1.3l0-1L123.5,2.7L123.5,2.7z M120.8,6.9 c0,0.5-0.4,0.9-0.9,0.9h-7.3c-0.5,0-0.9-0.4-0.9-0.9V3.2c0-0.5,0.4-0.9,0.9-0.9h7.3c0.5,0,0.9,0.4,0.9,0.9V6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.edbb11abb95e615e542fdb6d9db1542e.svg";
export { ForwardRef as ReactComponent };